<template>
  <div :class="`section-row section-${item.sectionIndex}`" :style="{'height': item.height + 'px'}">

    <div v-if="groupType === 'date-from-to'" class="td value">
      {{ flightDateLabel }}
      <el-divider direction="vertical" />
      {{ item.value.from }}
      -
      {{ item.value.to }}
    </div>

    <div v-else-if="groupType === 'date-org'" class="td value">
      {{ flightDateLabel }}
      <el-divider direction="vertical" />
      {{ organizationLabel }}
    </div>

    <div v-else-if="groupType === 'flight'" class="td value">
      <template v-if="item.value.flight">
        {{ flightNum }}
        <el-divider direction="vertical" />
        {{ flightFlightDateLabel }}
        <el-divider direction="vertical" />
        {{ item.value.flight.info.time || '--:--' }}
        <el-divider direction="vertical" />
        {{ item.value.flight.depPortLabels.label }} - {{ item.value.flight.arrPortLabels.label }}
        <el-divider direction="vertical" />
        <span :title="getTranserManagerContacts(item.value.flight.info.transferManagerId)" class="manager">
          <i class="el-icon-user" />
          {{ getTranserManagerName(item.value.flight.info.transferManagerId) }}
        </span>
        <el-tag v-for="status in item.value.flight.statusList"
                :key="status"
                :type="statusType(status)"
                class="flight-status-tag">
          {{ $t('flights.status.' + status) }}
        </el-tag>
      </template>
      <template v-else>
        {{ $t('flights.without') }}
      </template>
    </div>

    <div v-else>
      {{ item.value }}
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { getRoleUserById } from '@/utils/user'

export default {
  props: ['item', 'index', 'groupType'],

  computed: {
    flightDateLabel () {
      return this.formatDate(this.item.value.flightDate)
    },
    flightFlightDateLabel () {
      return this.formatDate(this.item.value.flight.flightDate)
    },
    organizationLabel () {
      return this.item.value['orderData.organization']
    },
    flightNum () {
      if (!this.item.value.flight) {
        return ''
      }
      return this.item.value.flight.ak + (this.item.value.flight.info.flightNum || '---')
    }
  },
  methods: {
    statusType (status) {
      switch (status) {
        case 'open':
        case 'closed':
        case 'expected':
          return ''
        case 'departed':
        case 'arrived':
          return 'success'
        case 'med-check':
          return 'warning'
        default:
          return 'info'
      }
    },
    formatDate (date) {
      return date ? moment(date).utc(true).format('YYYY-MM-DD') : ''
    },
    getTranserManagerName (userId) {
      const manager = getRoleUserById('TRANSFER_MANAGER', +userId)
      return manager ? manager.labels.shortName : '-'
    },
    getTranserManagerContacts (userId) {
      const manager = getRoleUserById('TRANSFER_MANAGER', +userId)
      return manager ? manager.userData['[PHONE]'] : ''
    }
  }
}
</script>

<style scoped>
  .section-row {
    width: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    margin: 0px 10px;
  }

  .manager {
    font-style: italic;
  }

  .flight-status-tag {
    margin-left: 1rem;
    height: 29px;
    line-height: 29px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flight-orders/scrolled/GroupRow.vue